/**
 * Detecção online/offline para pausar flush e replay automático.
 */

type NetworkListener = (online: boolean) => void;

let isOnline =
  typeof navigator === 'undefined' ? true : navigator.onLine !== false;
const listeners = new Set<NetworkListener>();
let attached = false;

function notify(): void {
  for (const fn of listeners) fn(isOnline);
}

export function getNetworkOnline(): boolean {
  return isOnline;
}

export function onNetworkChange(listener: NetworkListener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function initNetworkDetection(): void {
  if (typeof window === 'undefined' || attached) return;
  attached = true;
  window.addEventListener('online', () => {
    isOnline = true;
    notify();
  });
  window.addEventListener('offline', () => {
    isOnline = false;
    notify();
  });
}

export function _testSetNetworkOnline(value: boolean): void {
  isOnline = value;
  notify();
}
